import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {UiInputControl} from '../../../models/uiArtefakt';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {EventService} from '../../../services/event.service';
import {MenuSeite} from '../../../models/menuState';
import {Observable, Subscription, tap} from 'rxjs';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIWorkflowValidierung} from '../../../models/uiWorkflowValidierung';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'lv-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    standalone: false
})
export class MenuItemComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  menuSeite: MenuSeite;

  public menuItemRequested: string;
  public selectedSeite$: Observable<string>;
  public isDisabled: boolean = false;
  public uiControlsRequestPending: boolean;
  public highestClickedMenuItem$: Observable<number>;
  private _uiControlsRequestPendingSubscription$ = Subscription.EMPTY;
  private _uiArtefakt: UiInputControl;
  private _selectedSeite: string;

  constructor(private _eventService: EventService, private _shellConfigService: ShellConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt() {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: UiInputControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED
        || !this.menuSeite.enabled && this._shellConfigService.getParameter().uiWorkflowValidierung !==
        UIWorkflowValidierung.WORKFLOW_VALIDIERUNG_ALLES_GLEICHZEITIG;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }


  ngOnInit(): void {
    this.highestClickedMenuItem$ = this._eventService.highestClickedMenuItem$.asObservable();
    this._uiControlsRequestPendingSubscription$ = this._eventService.uiControlsRequestPending$
      .subscribe(requestPending => this.uiControlsRequestPending = requestPending);
    this.selectedSeite$ = this._eventService.menuItemSelected$.asObservable().pipe(
        tap(seite => {
          this.menuItemRequested = void 0;
          this._selectedSeite = seite;
        }));
  }

  onClickMenueItem() {
    if (this.menuSeite.Identifikator === this._selectedSeite) {
      return;
    }
    this.menuItemRequested = this.menuSeite.Identifikator;
    this._eventService.menuItemRequested$.next(this.menuSeite.Identifikator);
  }

  ngOnDestroy(): void {
    if (!!this._uiControlsRequestPendingSubscription$) {
      this._uiControlsRequestPendingSubscription$.unsubscribe();
    }
  }

}
